import React from 'react';

const PanoramaDecoration = () => (
  <svg
    width="670"
    height="224"
    viewBox="0 0 670 224"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="239.897" height="141.309" fill="#7EB54F" />
    <rect x="0.5" y="0.5" width="238.835" height="222.506" stroke="#65933E" />
    <rect
      x="23.9731"
      y="126.52"
      width="152.811"
      height="26.29"
      fill="#65933E"
    />
    <line
      x1="23.4731"
      y1="170.956"
      x2="186.765"
      y2="170.956"
      stroke="#E5F0DB"
    />
    <line
      x1="23.4731"
      y1="184.224"
      x2="155.127"
      y2="184.224"
      stroke="#E5F0DB"
    />
    <line
      x1="23.4731"
      y1="197.492"
      x2="165.333"
      y2="197.492"
      stroke="#E5F0DB"
    />
    <g opacity="0.5">
      <rect x="277.597" width="239.897" height="141.309" fill="#7EB54F" />
      <rect
        x="278.097"
        y="0.5"
        width="238.835"
        height="222.506"
        stroke="#65933E"
      />
      <rect
        x="301.57"
        y="126.52"
        width="152.811"
        height="26.29"
        fill="#65933E"
      />
      <line
        x1="301.07"
        y1="170.956"
        x2="464.362"
        y2="170.956"
        stroke="#E5F0DB"
      />
      <line
        x1="301.07"
        y1="184.224"
        x2="432.724"
        y2="184.224"
        stroke="#E5F0DB"
      />
      <line
        x1="301.07"
        y1="197.492"
        x2="442.93"
        y2="197.492"
        stroke="#E5F0DB"
      />
    </g>
    <g opacity="0.25">
      <rect x="555.193" width="239.897" height="141.309" fill="#7EB54F" />
      <rect
        x="555.693"
        y="0.5"
        width="238.835"
        height="222.506"
        stroke="#65933E"
      />
      <rect
        x="579.167"
        y="126.52"
        width="152.811"
        height="26.29"
        fill="#65933E"
      />
      <line
        x1="578.667"
        y1="170.956"
        x2="741.959"
        y2="170.956"
        stroke="#E5F0DB"
      />
      <line
        x1="578.667"
        y1="184.224"
        x2="710.321"
        y2="184.224"
        stroke="#E5F0DB"
      />
      <line
        x1="578.667"
        y1="197.492"
        x2="720.527"
        y2="197.492"
        stroke="#E5F0DB"
      />
    </g>
  </svg>
);

export default PanoramaDecoration;
